import { useMemo } from 'react'
import type { FactoryHookType } from '../type'
import maybeCreateCurrentRatingFilterNode from './CurrentRatingFilterNodeFactory'

const useCurrentRatingFilterNode: FactoryHookType = ({ RendererComponent, options }) => {
  return useMemo(() => {
    return maybeCreateCurrentRatingFilterNode({
      componentType: options.componentType,
      RendererComponent,
    })
  }, [options.componentType, RendererComponent])
}

export default useCurrentRatingFilterNode
